// extracted by mini-css-extract-plugin
export default {"LeaderboardsWrapper":"LeaderBoardsModal_LeaderboardsWrapper__dWqmu","EmptyText":"LeaderBoardsModal_EmptyText__gMDvU"};